import { publicEncrypt } from 'crypto';

export default function encrypt(toEncrypt) {
    const publicKey =
        '-----BEGIN RSA PUBLIC KEY-----\nMIGJAoGBANinvselm2gF3peoSuXr4b28fPgTIbDMuJgRlubNs3z0e1PybTWWs8rlXMXzGsVk98BuKD3p/c2s80Qm9KgFrQUKvt3gOiIaGld34+na0aYfB6MYVk9JzvtuI4WlA7FAqClJZl1BxxcLHjJ6dttrS3frwZV3tPejbpmhC5eMfklZAgMBAAE=\n-----END RSA PUBLIC KEY-----\n';
    const buffer = Buffer.from(toEncrypt, 'utf8');
    const encrypted = publicEncrypt(publicKey, buffer);
    return encrypted.toString('base64');
}
